export default __webpack_public_path__ + "static/media/unknown-user-logo.dad93a84.svg";